import * as React from 'react';
import { Table, SortableTableHeader } from "soprasteria-ui-library";
import { IOrthodonticLkgCfPatientExtension } from '../../../models/IOrthodonticLkgCfPatientExtension';
import { dateTimeToDateString } from '../../../helpers/DateHelper';
import { ORTHODONTIC_LKGCF_PATIENT_EXTENSION, PATIENT } from '../../../utils/RouteConstants';
import { Link } from 'react-router-dom';

interface IOrthodonticLkgCfPatientExtensionSearchTable {
    orthodonticLkgCfPatientExtensions: IOrthodonticLkgCfPatientExtension[];
}

export const OrthodonticLkgCfPatientExtensionSearchTable: React.FunctionComponent<IOrthodonticLkgCfPatientExtensionSearchTable> = ({ orthodonticLkgCfPatientExtensions }) => {

    const renderTableLink = (orthodonticLkgCfPatientExtension: IOrthodonticLkgCfPatientExtension, linkText?: string) => {
        return <Link to={`${PATIENT}/${orthodonticLkgCfPatientExtension.patientGuidId}/${ORTHODONTIC_LKGCF_PATIENT_EXTENSION}/${orthodonticLkgCfPatientExtension.orthodonticLkgCfPatientExtensionId}`}>{linkText}</Link>
    }

    return (
        <Table hoverableRows>
            <thead>
                <tr>
                    <SortableTableHeader propertyToSortBy="RegDate" headerText="Datum skickad" />
                    <th>Vårdgivarens namn</th>
                    <th>Mottagningens namn</th>
                    <SortableTableHeader propertyToSortBy="OrthodonticLkgCfPatientExtensionStatusId.Description" headerText="Status" />
                </tr>
            </thead>
            <tbody>
                {
                    orthodonticLkgCfPatientExtensions.length > 0 ?
                        orthodonticLkgCfPatientExtensions.map((orthodonticLkgCfPatientExtension, key) =>
                            <tr key={key} className="clickable-row">
                                <td className="table-data-link">{renderTableLink(orthodonticLkgCfPatientExtension, dateTimeToDateString(orthodonticLkgCfPatientExtension.regDate))}</td>
                                <td className="table-data-link">{renderTableLink(orthodonticLkgCfPatientExtension, orthodonticLkgCfPatientExtension.careProvider.displayOrganisationInformation)}</td>
                                <td className="table-data-link">{renderTableLink(orthodonticLkgCfPatientExtension, orthodonticLkgCfPatientExtension.careProvider.displayCareProviderName)}</td>
                                <td className="table-data-link">{renderTableLink(orthodonticLkgCfPatientExtension, orthodonticLkgCfPatientExtension.orthodonticLkgCfPatientExtensionStatus)}</td>
                            </tr>
                        )
                        : <tr><td colSpan={4}>Hittade inga ansökningar om förlängning av LKG/CF</td></tr>
                }
            </tbody>
        </Table>
    )
}